module.exports = __webpack_public_path__ + "static/media/javascript.aa209ab8.png";